// extracted by mini-css-extract-plugin
export var footer = "_np-0";
export var inherit = "_np-1";
export var input = "_np-2";
export var modalContent = "_np-3";
export var quillEditor = "_np-4";
export var subtitle = "_np-5";